<template>
    <div>
        <organization-list ref="orgList" :organizations="organizations" :pp="pp" @search="onSearch" @on-click-remove="onClickRemoveOrg"></organization-list>
        <div class="text-center">
            <v-pagination
                v-model="meta.current_page"
                :length="meta.last_page"
            ></v-pagination>
        </div>
        <dialog-confirm
            ref="dialogConfirmRm"
            title="Удаление организации"
            :text="'Вы действительно хотите удалить организацию ' + onRemoveOrg.short_name + '?'"
            @confirm="() => remove(onRemoveOrg.id)"
            @close="resetRMOrg">

        </dialog-confirm>
        <v-overlay v-show="organizations.length > 0" :value="pending" absolute="absolute" opacity="0.3">
            <v-progress-circular
                indeterminate
                size="50"
            ></v-progress-circular>
        </v-overlay>
    </div>
</template>

<script>
import OrganizationList from '@/components/Organization/OrganizationList.vue';
import * as organizationApi from '@/api/organizations';
import {mapActions, mapGetters} from 'vuex';
import _ from "lodash";
import DialogConfirm from "../../app/components/DialogConfirm.vue";

export default {
  components: {DialogConfirm, OrganizationList },
  name: 'OrganizationUserList',
  props:{
  },
  mounted(){
      this.load();
      this.resetRMOrg();
  },
  data(){
    return {
        organizations: [],
        meta: {
            current_page: 1,
            total: 0,
            last_page: 1,
            per_page: 15,
        },
        pending: false,
        filter:{
            name: ''
        },
        onRemoveOrg: {short_name:null}
    }
  },
    methods: {
        ...mapActions('notifications', ['SHOW_SUCCESS', 'SHOW_RESPONSE_ERROR']),
        ...mapActions('workspace', ['RELOAD_WORK_SPACE']),
        onSearch: _.debounce(async function(val){
            this.filter.name = val;
            this.load();
        }, 1000),
        onClickRemoveOrg(org){
            this.onRemoveOrg = org;
            this.$refs.dialogConfirmRm.show();
        },
        resetRMOrg() {
            this.onRemoveOrg = {short_name:null};
        },
        async remove(orgId){
            try {
                let response = await organizationApi.remove(this.ID_WORK_SPACE, orgId);
                this.SHOW_SUCCESS(response.data.message);
            }catch (e){
                this.SHOW_RESPONSE_ERROR({errorResponse: e, defaultError: 'Произошла ошибка удаления ('});
                console.log(e);
            }finally {
                this.resetRMOrg();
                this.load();
                this.RELOAD_WORK_SPACE();
            }
        },
        async load(){
            try{
                this.togglePending();
                let response = await organizationApi.workspaceOrganizations(this.ID_WORK_SPACE, {page: this.meta.current_page, ...this.filter});
                this.setOrganizations(response.data.data);
                this.meta = {...response.data, data: null};
            }catch(e){
                console.log(e);
            }finally{
                this.togglePending();
            }
        },
        togglePending(){
            this.pending = ! this.pending;
        },
        setOrganizations(organizations){
            this.organizations.splice(0, this.organizations.length, ...organizations);
        }
    },
    watch:{
        'meta.current_page': function () {
            this.load();
        }
    },
    computed: {
        pp(){
            return (this.meta.current_page - 1) * this.meta.per_page;
        },
        ...mapGetters( 'user', ['USER_ID']),
        ...mapGetters( 'workspace', ['ID_WORK_SPACE']),
    }
}
</script>